import { Component } from '@angular/core'

@Component({
  selector: 'mb-import-export-cart',
  templateUrl: './import-export-cart.component.html',
})
export class ImportExportCartComponent {
}
